import React, { useState } from "react";
import Images from "assets/images";
import Button from "components/buttons/Button";
import useToastify from "hooks/useToastify";
import { bh_sub_steps } from "helpers/enum";
import BHLegalAgreementContent from "./BHLegalAgreementContent";

function BHLegalAgreement({
  incompleteData,
  setActiveIndex,
  updateVisit,
  updatingVisit,
}) {
  const { showAlert } = useToastify();
  const [agreementAccepted, setAgreementAcceped] = useState(
    incompleteData?.accepted_legal_step
  );
  const [cancellationPolicyAccepted, setCancellationPolicyAccepted] = useState(
    incompleteData?.accepted_legal_step
  );
  const [signature, setSignature] = useState(incompleteData?.accepted_legal_step_by);
  const acceptAgreement = () => {
    updateVisit({
      payload: {
        case: {
          accepted_legal_step: agreementAccepted,
          medications:
            typeof incompleteData?.medications[0] === "string"
              ? incompleteData?.medications.map((item) => ({
                  name: item,
                }))
              : incompleteData?.medications?.map((med) => {
                  return {
                    ...med?.details,
                    name: med?.name,
                  };
                }),
          bh_second_phase_steps: {
            ...incompleteData?.bh_second_phase_steps,
            [bh_sub_steps.accepted_legal_step]: "completed",
          },
          accepted_legal_step_by: signature,
        },
      },
      change_current_screen: false,
      screen_to_complete: null,
      callBack: () => {
        showAlert("Agreement Accepted", "success");
        setActiveIndex(13);
      },
    });
  };

  return (
    <div className="bg-white rounded-b-4xl p-10">
      <div className="overflow-y-scroll h-96 font-medium text-xl">
        <BHLegalAgreementContent />
        <div className="py-5">
          <div
            onClick={() => setAgreementAcceped((prev) => !prev)}
            className="flex cursor-pointer"
          >
            <img
              className="w-10 h-10"
              src={
                agreementAccepted
                  ? Images.checkedOrange
                  : Images.uncheckedCircle
              }
              alt="checked"
            />
            <p className="pl-5 text-2xl leading-8 font-bold pt-1">
              I have read and agree to the terms of the agreement
            </p>
          </div>
        </div>
        <div className="py-5">
          <div
            onClick={() => setCancellationPolicyAccepted((prev) => !prev)}
            className="flex cursor-pointer"
          >
            <img
              className="w-10 h-10"
              src={
                cancellationPolicyAccepted
                  ? Images.checkedOrange
                  : Images.uncheckedCircle
              }
              alt="checked"
            />
            <p className="pl-5 text-2xl leading-8 font-bold pt-1">
              I have read and agree to the Cancellation and No Show Policy
            </p>
          </div>
        </div>
      <div className="py-5">
        <input className="w-full text-2xl py-4 pl-4 border border-gray-300 rounded-md outline-black outline-1" type="text" value={signature} onChange={(e) => setSignature(e.target.value)} placeholder="Enter your full name for acknowledgement" />
      </div>
      </div>
      <Button
        disabled={!agreementAccepted || !cancellationPolicyAccepted || !signature}
        loading={updatingVisit}
        className="mt-5 py-4"
        label="Next"
        onClick={acceptAgreement}
      />
    </div>
  );
}

export default BHLegalAgreement;
